
export function saveAuth(auth) {
    localStorage.setItem("chp.auth", JSON.stringify(auth));
  }

  export function getAuth(time) {
    const authString = localStorage.getItem("chp.auth");
    return JSON.parse(authString);
  }

  export function clearAuth() {
    localStorage.clear();
  }